import React from 'react';
import Helmet from "react-helmet";
import { withRouter, RouteComponentProps } from 'react-router';

// model
import Data from '../../model/Data';
// Local components
import Header from './components/Header/Header';
import Description from './components/Description/Description';
import Conditions from './components/Conditions/Conditions';
import VacanciesList from './components/VacanciesList/VacanciesList';
import DesktopFormBlock from './components/DesktopFormBlock/DesktopFormBlock';
import MobileFormBlock from './components/MobileFormBlock/MobileFormBlock';
// styles
import './Referal.css';
import './Referal320.css';
import './Referal768.css';
import './Referal1024.css';
import './Referal1280.css';
import './Referal1376.css';
import './Referal1920.css';
// helpers
import ResizeHelper from '../../common/helpers/resize';
import setCustomVw from '../../common/helpers/custom-vw';
import useYandexRotor from "../../common/helpers/useYandexRotor";


interface MatchParams {
  id: string;
  city: string;
}

type Props = RouteComponentProps<MatchParams>;


class Referal extends React.Component<Props, {vacancy: string | undefined}> {

  constructor(props: Props) {
    super(props);
    this.state = {
      vacancy: undefined
    }
    ResizeHelper.Instance.addCallback(this.refresh.bind(this));
  }

  componentDidMount() {
    Data.getVacancyReferalBridge().then(data => {
      if (data) {
        this.setState({vacancy: data.id})
      }
    }).catch(error => {
      Sentry.captureException(error);
    });
    setCustomVw();
  }

  refresh(): void {
    this.setState((prevState) => ({...prevState}));
  }

  render(): JSX.Element {
    const { vacancy } = this.state;
    useYandexRotor(Data.Instance.isDataLoaded);

    return (
      <div className="referal">
        <Helmet
          title="Реферальная программа в UChi.ru"
          key={`referals-head`}
        />
        <Header />
        <Description key={`descr-referal`} />
        <Conditions />
        <VacanciesList />
        <MobileFormBlock className="hidden mobile-visible tablet-visible" vacancy={vacancy}/>
        <DesktopFormBlock className="mobile-hidden tablet-hidden" vacancy={vacancy}/>
      </div>
    );
  }
}

export default withRouter(Referal);
